import React from 'react';
import { Link } from "react-router-dom"; // Dodato za navigaciju
import { Button, Row, Col, Dropdown  } from "react-bootstrap";
import CoFButton from '../Button/CoFButton.js'
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
const Footer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);  // Sačuvaj izabrani jezik u localStorage
  };
  const handleDemoClick = () => {
    // Navigacija na novu stranicu kada se klikne na "Get a Demo"
    navigate('/demo');
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Dodajte 'smooth' za glatko pomeranje
    });
  };

const appBaseUrl = process.env.REACT_APP_APP_BASE_URL;

// Dodajte putanje za prijavu i registraciju na base URL
const signUpUrl = `${appBaseUrl}/signup`;
const signInUrl = `${appBaseUrl}/signin`;

// Handler funkcija za klik na dugme "Sign In"
const handleSignUpClick = () => {
  // Preusmeravanje na stranicu za registraciju
  window.location.href = signUpUrl;
};

const handleSignInClick = () => {
  // Preusmeravanje na stranicu za prijavljivanje
  window.location.href = signInUrl;
};
  
  return (
    <footer className="container-fluid text-center footer-container">
    <div className="container mx-auto row justify-content-between align-items-center">
      {/* Prva vrsta footera */}
      <Col xl={3}  xs={12}>
        <div className="footer-section align-self-start" style={{ textAlign: 'left' }}>
          <Link to="/">
            <img src="/images/logo.png" alt="Logo" style={{ height: "45px" }} />
          </Link>
        </div>
      </Col>
      <Col xl={9}  xs={12} className="d-flex align-items-center justify-content-end">
        <div className="footer-buttons">
          <CoFButton buttonText={t("Uloguj se")} onClick={handleSignInClick} />
          <CoFButton buttonText={t("Registruj se" )} onClick={handleSignUpClick}/>
          <CoFButton buttonText={t("Zakazi demo")} onClick={handleDemoClick} hasBorder={true} borderColor="green" />
        </div>
      </Col>
    </div>

    <div className="container mx-auto row justify-content-start mt-1">
      <p style={{ textAlign: 'left', color: '#78789A' }}>{t("Aplikacija za kominikaciju i organizaciju unutar fudbalskih klubova")}</p>
    </div>

    <div className="container mx-auto">
      <div className="footer-divider"></div>
    </div>

      <div className="row container mx-auto text-left">
        {/* Druga vrsta footera */}
        <div className="col-md-3" style={{ textAlign: 'left' }}>
          <div className="footer-section">
            <h5 className="font-weight-bold">{t("Proizvod")}</h5>
            <ul className="list-unstyled">
              <li><a href="/solutions" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Upotreba")}</a></li>
              <li><a href="/whyuse" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Zasto COF")}</a></li>
              {/* Dodajte više opcija po potrebi */}
            </ul>
          </div>
        </div>
        <div className="col-md-3" style={{ textAlign: 'left' }}>
          <div className="footer-section">
            <h5 className="font-weight-bold">{t("Resursi")}</h5>
            <ul className="list-unstyled">
              <li><a href="#" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Informacije")}</a></li>
              <li><a href="#" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Blog")}</a></li>
              <li><a href="#" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Tutorijali")}</a></li>
              {/* Dodajte više opcija po potrebi */}
            </ul>
          </div>
        </div>
        <div className="col-md-3" style={{ textAlign: 'left' }}>
          <div className="footer-section">
            <h5 className="font-weight-bold">{t("Kompanija")}</h5>
            <ul className="list-unstyled">
              <li><a href="/company" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Onama")}</a></li>
              <li><a href="/company" style={{ textDecoration: 'none', color: '#78789A'}}>{t("Nasa putanja")}</a></li>
              <li>
                <Link to="/politika-privatnosti" style={{ textDecoration: 'none', color: '#78789A' }}>
                  {t("Politika privatnosti")}
                </Link>
              </li>
              <li>
                <Link to="/uslovi-koriscenja" style={{ textDecoration: 'none', color: '#78789A' }}>
                  {t("Uslovi koriscenja")}
                </Link>
              </li>
              <li>
                <Link to="/kolacici" style={{ textDecoration: 'none', color: '#78789A' }}>
                  {t("Kolacici")}
                </Link>
              </li>
              {/* Dodajte više opcija po potrebi */}
            </ul>
          </div>
        </div>
        <div className="col-md-3" style={{ textAlign: 'left' }}>
          <div className="footer-section">
            <h5 className="font-weight-bold">{t("Zapratite nas")}</h5>
            <ul className="social-icons list-inline">
              <li className="list-inline-item"><a href="https://www.facebook.com/profile.php?id=61555956033757" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a></li>
              <li className="list-inline-item"><a href="https://www.instagram.com/cofftbl?igsh=MWswZHo0N25vNG9jbA==" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
              <li className="list-inline-item"><a href="https://www.youtube.com/@ConciergeofFotball/videos" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a></li>
              {/* Dodajte ikonice za ostale socijalne mreže */}
            </ul>
          </div>
          <Dropdown className="language-dropdown">
            <Dropdown.Toggle variant="outline-light" id="language-dropdown">
              {t("Jezik")}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1" onClick={() => changeLanguage('en')}>{t("Engleski")}</Dropdown.Item>
              <Dropdown.Item href="#/action-2" onClick={() => changeLanguage('srb')}>{t("Srpski")}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      
      <div className="container mx-auto">
        <div className="footer-divider"></div>
      </div>
      
      <div className="container mx-auto text-center">
        <p style={{ color: '#78789A', margin: '0', fontSize: '0.9rem' }}>
          © {new Date().getFullYear()} Concierge of Football. {t("Sva prava zadržana")}.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
